import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

export const EventCard = ({ event }) => {
    const [user] = useOutletContext();

    const navigate = useNavigate();

    // Définir les couleurs de bordure en fonction du type d'événement
    const borderColors = {
        INTERNAL: "border-blue-500",
        PRIVATE: "border-green-500",
        PUBLIC: "border-yellow-500",
        MECENAT: "border-blue-500",
        OVERTIME: "border-slate-500",
    };

    const bgColors = {
        INTERNAL: "bg-blue-500",
        PRIVATE: "bg-green-500",
        PUBLIC: "bg-yellow-500",
        MECENAT: "bg-blue-500",
        OVERTIME: "bg-slate-500",
    };

    const labelType = {
        INTERNAL: "Interne",
        PRIVATE: "Privé",
        PUBLIC: "Public",
        MECENAT: "Mécénat",
        OVERTIME: "H. supp.",
    };

    const borderColor = borderColors[event.type] || "border-gray-300";

    const isNew = new Date(user.last_seen_events) <= new Date(event.created_at);
    const isUpdated =
        !isNew && new Date(user.last_seen_events) <= new Date(event.updated_at);

    const minDate = new Date(
        Math.min(...event.shifts.map(s => new Date(s.start_time)))
    );
    const maxDate = new Date(
        Math.max(...event.shifts.map(s => new Date(s.end_time)))
    );

    return (
        <div
            className={`relative bg-white rounded-lg shadow-md p-4 flex flex-col items-center cursor-pointer border-2 ${borderColor}`}
            onClick={() =>
                navigate(
                    "/manifestation/manifestations/event/" +
                    event.id +
                    "/" +
                    (window.location.hash.replace("#", "") == ""
                        ? "PENDING"
                        : window.location.hash.replace("#", ""))
                )
            }
        >
            {/* Badge New */}
            {isNew && (
                <span className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-sm">
                    Nouveau
                </span>
            )}
            {isUpdated && (
                <span className="absolute top-2 right-2 bg-orange-400 text-white text-xs font-bold px-2 py-1 rounded-sm">
                    MàJ
                </span>
            )}
            <span
                className={`absolute top-2 left-2 text-white text-xs font-bold px-2 py-1 rounded ${bgColors[event.type]
                    }`}
            >
                {labelType[event.type]}
            </span>
            <img
                src="https://static.nationalgeographic.fr/files/styles/image_3200/public/93247.jpg?w=1900&h=1425"
                alt="Event Image"
                className="mb-4"
            />
            <h3 className="text-lg font-semibold text-gray-800">
                {event.name}<br />
                <span className="text-sm text-center">
                    {minDate.toDateString() === maxDate.toDateString()
                        ? `[${minDate.toLocaleDateString()}]`
                        : `[${minDate.toLocaleDateString()} - ${maxDate.toLocaleDateString()}]`}
                </span>            </h3>
            <p className="text-gray-500">{event.commandite}</p>
            <div className="text-gray-400 mt-2 text-sm">
                {event.shifts.length + " " + (event.shifts.length > 1 ? "créneaux" : "créneau")}
            </div>
        </div>
    );
};
